export class CheckInviteCodeResponse
{
    public readonly email:string;
    public readonly userGroupName:string;
    public readonly organizationName:string;
    public readonly organizationUrl:string;
    public readonly entity:string;
    public readonly allowed:boolean;
    public readonly message:string;

    constructor(json:any)
    {
        this.email = json['email'];
        this.userGroupName = json['userGroupName'];
        this.organizationName = json['organizationName'];
        this.organizationUrl = json['organizationUrl'];
        this.entity = json['entity'];
        this.allowed = json['allowed'];
        this.message = json['message'];
    }
}
